import { useTranslation } from "react-i18next";

import { SlidingSegmentedControl } from "../../../components/SlidingSegmentedControl";

export type HomeComposerMode = "chat" | "project";

/**
 * Home-only Chat / Project segmented control. Height and radius match the
 * Ask Puntt submit button (`size="2"` + `rounded-xl`); each segment sizes to
 * its label rather than stretching to a fixed equal width.
 */
export function HomeComposerModeToggle({
  value,
  onChange,
  testIdPrefix = "ask-puntt-home",
  "data-testid": dataTestId = "ask-puntt-home-composer-mode",
}: {
  value: HomeComposerMode;
  onChange: (mode: HomeComposerMode) => void;
  /** Prefix for segment + thumb testids when a second toggle is on screen. */
  testIdPrefix?: string;
  "data-testid"?: string;
}) {
  const { t } = useTranslation("ui");

  return (
    <SlidingSegmentedControl
      value={value}
      onChange={onChange}
      ariaLabel={t("home.composerModeAriaLabel")}
      data-testid={dataTestId}
      thumbTestId={`${testIdPrefix}-composer-mode-thumb`}
      items={[
        {
          id: "chat",
          testId: `${testIdPrefix}-mode-chat`,
          content: t("home.composerModeChat"),
        },
        {
          id: "project",
          testId: `${testIdPrefix}-mode-project`,
          content: t("home.composerModeProject"),
        },
      ]}
    />
  );
}
